import Mensagens from "../../utils/MensagemUtils";
import InputPadrao from "../InputPadrao/InputPadrao";
import DropdownPadrao from '../DropdownPadrao/DropdownPadrao';
import BotaoAdicionar from '../BotaoAdicionar/BotaoAdicionar';
import AvisoVazio from '../AvisoVazio/AvisoVazio';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import '../../pages/Cadastros.css';
import './CadastrarSistemaModal.css';
import { FaCheck } from "react-icons/fa6";
import LimitesSistema from "../LimitesSistema/LimitesSistema";
import NotificacaoUtils from "../../utils/NotificacaoUtils";
import { useState, useEffect } from 'react';
import ModalSistemas from '../ModalSistemas/ModalSistemas';
import api from '../../services/api';
import { FuncionalidadesAdicionais } from '../../utils/EnumsUtils';
import { parseDataString, TipoFormatacao } from '../../utils/FormatacaoUtils';
import { ValidacaoUtils, TipoValidacao } from '../../utils/ValidacaoUtils';
import TogglePadrao from '../TogglePadrao/TogglePadrao';
import ModalFuncionalidadeAdicional, { formatarItem } from '../ModalFuncionalidadeAdicional/ModalFuncionalidadeAdicional';

// Enum de sistemas padronizado
export const EnumSistemas = {
  DIXI_PONTO: 'Ponto',
  DIXI_CHAMADOS: 'Chamado',
  DIXI_ACESSOS: 'Acesso',
};

const FUNCIONALIDADES_NAO_AUTOMATICAS_CORPORATIVO = ['Cálculo Automático'];

const normalizarTexto = (texto = '') =>
  texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();

const NOMES_NORMALIZADOS_NAO_AUTOMATICOS = FUNCIONALIDADES_NAO_AUTOMATICAS_CORPORATIVO.map(normalizarTexto);

const CadastrarSistemaModal = ({
  onClickCancelar,
  onClickFinalizar,
  sistema,
  licencasExistentes = [],
  valoresIniciais = {},
  plano,
  editando
}) => {

  const [errors, setErrors] = useState({});
  const [limites, setLimites] = useState(valoresIniciais.limites || {});
  const [limitesErrors, setLimitesErrors] = useState({});
  const [modalFuncionalidadeAberto, setModalFuncionalidadeAberto] = useState(false);
  const [funcionalidadesVinculadas, setFuncionalidadesVinculadas] = useState([]);
  const [loadingFuncionalidades, setLoadingFuncionalidades] = useState(false);
  // Estado para armazenar as funcionalidades a serem vinculadas/removidas
  const [funcionalidadesParaVincular, setFuncionalidadesParaVincular] = useState({
    idsFuncionalidadesAdicionar: [],
    idsFuncionalidadesRemover: [],
    funcionalidadesSelecionadas: []
  });

  // Carrega funcionalidades vinculadas quando estiver editando
  useEffect(() => {
    const carregarFuncionalidades = async () => {
      if (!editando || !valoresIniciais?.id) {
        return;
      }

      try {
        setLoadingFuncionalidades(true);
        const resposta = await api.get(`/funcionalidadeAdicional_/all/${valoresIniciais.id}`);
        
        if (resposta && resposta.data && Array.isArray(resposta.data)) {
          const funcionalidesAtivas = resposta.data.filter(f => f.ativo !== false);
          setFuncionalidadesVinculadas(funcionalidesAtivas);
        }
      } catch (erro) {
        console.error('Erro ao carregar funcionalidades vinculadas:', erro);
      } finally {
        setLoadingFuncionalidades(false);
      }
    };

    carregarFuncionalidades();
  }, [editando, valoresIniciais?.id]);

  const handleAbrirModalFuncionalidade = () => {
    setModalFuncionalidadeAberto(true);
  };

  const handleLimparFuncionalidades = () => {
    setFuncionalidadesVinculadas([]);
    setFuncionalidadesParaVincular({
      idsFuncionalidadesAdicionar: [],
      idsFuncionalidadesRemover: [],
      funcionalidadesSelecionadas: []
    });
  };

  const handleAutoSelecionarCorporativo = async () => {
    try {
      setLoadingFuncionalidades(true);
      const idTipoSistema = sistemaToTipoId[sistema];
      const url = idTipoSistema
        ? `/funcionalidadeAdicional_?idTipoSistema=${idTipoSistema}`
        : '/funcionalidadeAdicional_';

      const resposta = await api.get(url);
      const dados = Array.isArray(resposta?.data)
        ? resposta.data
        : Array.isArray(resposta?.data?.content)
          ? resposta.data.content
          : [];

      const formatados = dados.map(formatarItem);
      const selecionadosAutomaticamente = formatados.filter(
        f => !NOMES_NORMALIZADOS_NAO_AUTOMATICOS.includes(normalizarTexto(f.nome))
      );
      const ids = selecionadosAutomaticamente.map(f => f.idFuncionalidadeAdicionalTipoSistema).filter(Boolean);

      setFuncionalidadesVinculadas(selecionadosAutomaticamente);
      setFuncionalidadesParaVincular({
        idsFuncionalidadesAdicionar: ids,
        idsFuncionalidadesRemover: [],
        funcionalidadesSelecionadas: selecionadosAutomaticamente
      });
    } catch {
      NotificacaoUtils.erro('Erro ao carregar funcionalidades adicionais');
    } finally {
      setLoadingFuncionalidades(false);
    }
  };

  const handleSalvarFuncionalidades = (dados) => {
    
    // Armazena os dados em memória
    setFuncionalidadesParaVincular(dados);
    
    // Atualiza a visualização com as funcionalidades selecionadas
    if (dados.funcionalidadesSelecionadas) {
      setFuncionalidadesVinculadas(dados.funcionalidadesSelecionadas);
    }
  };

  const handleFecharModalFuncionalidade = () => {
    setModalFuncionalidadeAberto(false);
  };

  // Mapeamento do nome do sistema para id_tipo_sistema usando EnumSistemas
  const sistemaToTipoId = {
    [EnumSistemas.DIXI_PONTO]: 1,
    [EnumSistemas.DIXI_ACESSOS]: 2,
    [EnumSistemas.DIXI_CHAMADOS]: 3,
  };

  // Filtra os planos conforme o sistema selecionado
  let planosFiltrados;
  // Regra especial: para Chamado, só exibe plano com id 7
  if (sistema === EnumSistemas.DIXI_CHAMADOS && Array.isArray(plano)) {
    planosFiltrados = plano.filter(p => p.id === 7);
  } else if (Array.isArray(plano) && sistema) {
    planosFiltrados = plano.filter(p => p.idTipoSistema === sistemaToTipoId[sistema]);
  } else {
    planosFiltrados = plano;
  }

  const [form, setForm] = useState(() => {
    let planoInicial = '';
    if (valoresIniciais.plano) {
      if (typeof valoresIniciais.plano === 'object' && Object.keys(valoresIniciais.plano).length > 0) {
        // Busca o objeto do plano pelo id, para garantir referência correta
        const planoObj = Array.isArray(planosFiltrados)
          ? planosFiltrados.find(p => p.id === valoresIniciais.plano.id)
          : null;
        planoInicial = planoObj || valoresIniciais.plano;
      } else if (typeof valoresIniciais.plano === 'string' && Array.isArray(planosFiltrados)) {
        planoInicial = planosFiltrados.find(
          p => p.descricao === valoresIniciais.plano || p.id?.toString() === valoresIniciais.plano
        ) || '';
      }
    }
    return {
      plano: planoInicial,
      numeroPedido: valoresIniciais.numeroPedido ? String(valoresIniciais.numeroPedido) : '',
      unidadeNegocio: valoresIniciais.unidadeNegocio || '',
      expiracao: valoresIniciais.expiracao || '',
      cancelamento: valoresIniciais.cancelamento === 'Não definido' ? '' : valoresIniciais.cancelamento || '',
      situacao:
        valoresIniciais.situacao !== undefined
          ? (valoresIniciais.situacao === true || valoresIniciais.situacao === 'ATIVO')
            ? true
            : false
          : true,
      // Lógica robusta para determinar se acessoSuporte é verdadeiro
      acessoSuporte: (() => {
        // Para strings, verifica se contém "Sim" ou "true" (case insensitive)
        if (typeof valoresIniciais.acessoSuporte === 'string') {
          const valor = valoresIniciais.acessoSuporte.toLowerCase();
          return valor === 'sim' || valor === 'true';
        }
        // Para booleanos ou outros tipos, compara diretamente com true
        return valoresIniciais.acessoSuporte === true;
      })(),
      sistema: sistema || '', // Adiciona o tipo de sistema ao form
    };
  });

  const handleInputChange = (e, field) => {
    if (field === 'plano') {
      if (e === '') {
        setForm({ ...form, plano: '' });
        handleLimparFuncionalidades();
      } else {
        setForm({ ...form, plano: e });
        if (e.descricao?.toLowerCase().includes('corporativo')) {
          handleAutoSelecionarCorporativo();
        } else {
          handleLimparFuncionalidades();
        }
      }
      if (errors.plano) setErrors({ ...errors, plano: null });
      return;
    }
    setForm({
      ...form,
      [field]: e.target.value,
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  const handleDataChange = (e, field) => {
    // Bloqueia valores com mais de 8 dígitos para campos de data
    let valorLimitado = e.target.value;
    if (field === 'expiracao' || field === 'cancelamento') {
      // Remove tudo que não for número e limita a 8 dígitos
      const apenasNumeros = valorLimitado.replace(/\D/g, '');
      if (apenasNumeros.length > 8) {
        valorLimitado = apenasNumeros.substring(0, 8);
      } else {
        valorLimitado = apenasNumeros;
      }
    }

    setForm({
      ...form,
      [field]: valorLimitado,
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  const handleSituacaoChange = (value) => {
    setForm({ ...form, situacao: value });
    if (errors.situacao) {
      setErrors({ ...errors, situacao: null });
    }
  };

  const handleAcessoSuporteChange = (value) => {
    // Convertemos explicitamente para booleano com === true
    // para garantir que não importa se recebemos string ou booleano
    const valorBooleano = value === true;
    setForm({ ...form, acessoSuporte: valorBooleano });
    if (errors.acessoSuporte) {
      setErrors({ ...errors, acessoSuporte: null });
    }
  };

  const handleLimitesChange = (novosLimites) => {
    setLimites(novosLimites);

    const chavesNovos = Object.keys(novosLimites);
    let houveMudanca = false;
    const novosErros = { ...limitesErrors };
    chavesNovos.forEach((chave) => {
      if (limitesErrors[chave] && novosLimites[chave]) {
        delete novosErros[chave];
        houveMudanca = true;
      }
    });
    if (houveMudanca) setLimitesErrors(novosErros);
  };

  const handleFinalizar = () => {
    // Inclui os limites no objeto de form para validação completa
    const formCompleto = {
      ...form,
      limites
    };

    const result = ValidacaoUtils.validateForm(formCompleto, TipoValidacao.LICENCA_CRIAR);
    setErrors(result.errors);

    // Mapeando os erros dos limites para o estado limitesErrors
    const errosLimites = {};
    Object.keys(result.errors).forEach(key => {
      if (key.startsWith('limites.')) {
        const campoDeLimite = key.replace('limites.', '');
        errosLimites[campoDeLimite] = result.errors[key];
      }
    });
    setLimitesErrors(errosLimites);

    if (!result.success) return;

    // Validação de unidade de negócio duplicada
    const unidadeAtual = form.unidadeNegocio?.trim().toLowerCase();
    const sistemaAtual = sistema?.trim().toLowerCase();
    const existeDuplicada = licencasExistentes.some(l =>
      l.unidade?.trim().toLowerCase() === unidadeAtual &&
      l.planoDTO?.descricaoTipoSistema?.trim().toLowerCase() === sistemaAtual
    );

    if (existeDuplicada && !editando) {
      NotificacaoUtils.erro('Unidade duplicada.');
      return;
    }

    const dadosParaExpor = {
      ...form,
      plano: form.plano || '',
      limites,
      situacao: form.situacao, // Mantém booleano
      // Garantimos que acessoSuporte seja estritamente booleano
      acessoSuporte: form.acessoSuporte === true,
      funcionalidadesVinculo: funcionalidadesParaVincular
    };
    
    if (onClickFinalizar) {
      onClickFinalizar(dadosParaExpor);
      
      // Limpa as funcionalidades após finalizar
      setFuncionalidadesParaVincular({
        idsFuncionalidadesAdicionar: [],
        idsFuncionalidadesRemover: [],
        funcionalidadesSelecionadas: []
      });
    }
  };

  return (
    <div className="cadastrar-sistema-wrapper">
      <div className="inputs-superiores">
        <div className="inputs-flex" style={{ gap: '20px' }}>
          <div className="linha-flex">
            <DropdownPadrao
              label={'Plano'}
              required={true}
              showFilter={true}
              value={form.plano}
              options={planosFiltrados}
              erroMensagem={errors.plano}
              onChange={option => handleInputChange(option, 'plano')}
              retornarObjeto={true}
              mapearOpcao={opt => ({
                value: opt.id?.toString() || '',
                label: opt.descricao || '',
                ...opt,
              })}
            />
            <InputPadrao
              label={'Número do Pedido'}
              placeholder={'Insira o número do pedido'}
              required={true}
              tipoFormatador={TipoFormatacao.NUMERO}
              value={form.numeroPedido}
              erroMensagem={errors.numeroPedido}
              maxLength={8}
              onChange={e => handleInputChange(e, 'numeroPedido')}
            />
            <InputPadrao
              label={'Unidade'}
              placeholder={'Insira a unidade'}
              required={true}
              permiteEspacos={false}
              value={form.unidadeNegocio}
              erroMensagem={errors.unidadeNegocio}
              onChange={e => handleInputChange(e, 'unidadeNegocio')}
            />
          </div>
          <div className="linha-flex">
            <InputPadrao
              label={'Data de cancelamento'}
              placeholder={'data de cancelamento'}
              tipoFormatador={TipoFormatacao.DATA}
              value={form.cancelamento}
              erroMensagem={errors.cancelamento}
              onChange={e => handleDataChange(e, 'cancelamento')}
            />
            <InputPadrao
              label={'Data de expiração'}
              placeholder={'data de expiração'}
              required={true}
              tipoFormatador={TipoFormatacao.DATA}
              value={form.expiracao}
              erroMensagem={errors.expiracao}
              onChange={e => handleDataChange(e, 'expiracao')}
            />
            <div className="toggle-wrapper">
              <TogglePadrao
                label="Situação cadastro"
                value={form.situacao}
                onChange={handleSituacaoChange}
                disabled={!editando && (!valoresIniciais || !valoresIniciais.id || valoresIniciais.id === 0)}
              />
              <TogglePadrao
                label="Possui Suporte"
                textoAtivo="Sim"
                textoInativo="Não"
                value={form.acessoSuporte}
                onChange={handleAcessoSuporteChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="cabecalho-inputs-meio">
        <h3>Limites</h3>
      </div>

      <hr className="divisor" />

      <div className="inputs-meio">
        <div className="inputs-flex">
          <div className="linha-flex">
            <LimitesSistema
              sistema={sistema}
              valores={limites}
              onChange={handleLimitesChange}
              erros={limitesErrors}
            />
          </div>
        </div>
      </div>

      <div className="cabecalho-inputs-fim">
        <h3>Funcionalidades Adicionais</h3>
        <BotaoAdicionar
          aoClicar={handleAbrirModalFuncionalidade}
        />
      </div>

      <hr className="divisor" />

      <div className="inputs-fim">
        {loadingFuncionalidades ? (
          <AvisoVazio
            titulo={'Carregando...'}
            mensagem={'Buscando funcionalidades vinculadas'}
          />
        ) : funcionalidadesVinculadas.length > 0 ? (
          <div className="funcionalidades-vinculadas">
            <div className="lista-funcionalidades">
              {funcionalidadesVinculadas.map((func, index) => {
                const descricao = func.funcionalidadeTipoSistema?.funcionalidade?.descricao 
                  || func.descricaoFuncionalidadeAdicional 
                  || func.descricao
                  || func.funcionalidade;
                
                // Mapeia para o enum
                const descricaoNormalizada = descricao?.toLowerCase().replace(/\s+/g, '');
                let nomeExibicao = descricao;
                
                for (const [chave, valor] of Object.entries(FuncionalidadesAdicionais)) {
                  const enumNormalizado = valor.toLowerCase().replace(/\s+/g, '');
                  if (descricaoNormalizada?.includes(enumNormalizado) || enumNormalizado?.includes(descricaoNormalizada)) {
                    nomeExibicao = valor;
                    break;
                  }
                }
                
                return (
                  <div key={index} className="funcionalidade-item">
                    <span className="funcionalidade-nome">{nomeExibicao}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <AvisoVazio
            titulo={'Nenhuma funcionalidade adicional cadastrada'}
            mensagem={'Para cadastrar, clique acima em'}
            mensagemDestaque={'Adicionar +'}
          />
        )}
      </div>

      <div className="botoes">
        <BotaoPadrao cancelar={true} texto={'Cancelar'} aoClicar={onClickCancelar} />
        <BotaoPadrao
          texto={'Finalizar Cadastro'}
          confirmar={true}
          icone={<FaCheck />}
          aoClicar={handleFinalizar}
        />
      </div>
      {/* Modal de funcionalidades adicionais */}
      <ModalSistemas
        aberto={modalFuncionalidadeAberto}
        titulo={`Adicionar Licença - ${sistema || ''}`}
        onClose={handleFecharModalFuncionalidade}
        subtitulo={'Selecione funcionalidades para adicionar ou remover da licença'}
        className={"modal-funcionalidade-adicional"}
        overlayClassName={"modal-sistemas-overlay-secundario"}
      >
        <ModalFuncionalidadeAdicional
          unidadeNegocio={form.unidadeNegocio}
          plano={form.plano}
          tipoSistema={sistema}
          idSistema={valoresIniciais?.id}
          funcionalidadesSelecionadas={funcionalidadesParaVincular.funcionalidadesSelecionadas}
          onSalvar={handleSalvarFuncionalidades}
          onCancelar={handleFecharModalFuncionalidade}
        />
      </ModalSistemas>
    </div>
  );
};

export default CadastrarSistemaModal;